import PartnerPageTable from "./PartnerPageTable";
export default function PartnerStatisticsPage() { return <PartnerPageTable title="Վիճակագրություն" subtitle="Դիտեք ձեր գործընկերային ծրագրի մանրամասն վիճակագրությունը" rows={[]} />; }
